import React from 'react'
import {
   AIDrivenSmartTravelIcon,
   AIPoweredHealthInsightsIcon,
   ContinuousSupportIcon,
   CustomHealthFitnessIcon,
   CustomTailoredTravelIcons,
   OmnichannelTravelIcon,
   ScalableCloudBasedIcon,
   ScalableSolutionsIcon,
   SecureCompliantDataIcon,
   SecureTransactionsIcon,
   WearablesHealthIcon,
} from '@/svgs'
import { WhyChooseOur } from '@/components'

const featureCards = [
   {
      title: 'Custom Health & Fitness Software',
      subtitle: 'Tailored Solutions for Gyms & Clinics',
      description:
         'We build custom health and fitness applications, including gym management software, telehealth platforms, and wellness tracking solutions, ensuring seamless service delivery and user experience.',
      icon: <CustomHealthFitnessIcon />,
   },
   {
      title: 'AI-Powered Health Insights',
      subtitle: 'Personalized Insights & Data Tracking',
      description:
         'We implement AI-driven analytics tools that assess user health metrics, workout patterns, and lifestyle habits, helping businesses deliver data-driven fitness plans and health insights.',
      icon: <AIPoweredHealthInsightsIcon />,
   },
   {
      title: 'Secure & Compliant Data Management',
      subtitle: 'HIPAA-Compliant Encryption & Protection',
      description:
         'We provide HIPAA, GDPR, and industry standards compliance, implementing end-to-end encryption and safe data storage for the protection of user health information.',
      icon: <SecureCompliantDataIcon />,
   },
   {
      title: 'Seamless Integration with Wearables & Systems',
      subtitle: 'Syncs with Devices & Health Records',
      description:
         'We implement cloud-based systems that integrate wearables, electronic medical records (EMR), and IoT, supporting real-time tracking of health and synchronization of data.',
      icon: <WearablesHealthIcon />,
   },
   {
      title: 'Scalable Cloud-Based Solutions',
      subtitle: 'Multi-Location & Remote Management',
      description:
         'Our cloud-powered fitness solutions enable real-time data synchronization, remote coaching, and multi-location gym or clinic management, supporting seamless scalability.',
      icon: <ScalableSolutionsIcon />,
   },
   {
      title: 'Ongoing Support & System Upgrades',
      subtitle: 'Feature Enhancements & Maintenance',
      description:
         'We offer 24/7 technical support, security patches, and feature updates to make health and fitness platforms competitive, effective, and future-proof.',
      icon: <ContinuousSupportIcon />,
   },
];

function HealthFitnessWhyChoose() {
   return (
      <>
         <WhyChooseOur
         classCustom='fintech_custom_why_choose'
            title={
               'Why Choose Our Health & Fitness Software Development Services?'
            }
            desc={
               'We provide safe, scalable, and focused on customers health and fitness solutions that boost digital transformation, user engagement, and business growth. Here\'s why companies trust us:'
            }
            cardData={featureCards}
            otherUi={true}
         />
      </>
   )
}

export default HealthFitnessWhyChoose
